<template>
    <div class="pt-8" v-show="recommendationProducts.length > 0">
        <div class="normal-container !py-0">
            <h2 class="mb-4 text-xl leading-none lg:mb-10 lg:text-3xl">
                {{ $snippets['headless.pdp.recommendationsTitle'] }}
            </h2>
        </div>
        <div class="relative w-full overflow-hidden">
            <div class="normal-container mb-6 lg:mb-32">
                <LazyUiSlider ref="slider">
                    <div
                        v-for="(product, index) in recommendationProducts"
                        :key="product?.id || index"
                        class="min-w-[181px] max-w-[181px] lg:min-w-[281px] lg:max-w-[281px]"
                        :class="['keen-slider__slide number-slide' + index]">
                        <div class="min-w-[181px] max-w-[181px] lg:min-w-[281px] lg:max-w-[281px]">
                            <ShopwareProduct size="big" showLabels :product="product" />
                        </div>
                    </div>
                </LazyUiSlider>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps<{ products?: any[] }>();
    const slider = useTemplateRef('slider');

    const recommendationProducts = computed(() => props.products ?? []);

    onUpdated(() => {
        slider?.value?.update();
    });
</script>
